import styled from 'vue-styled-components';

export default styled.svg`
  display: ${({ theme }) =>
    theme.prefs.showHomescreenCloud ? 'block' : 'none !important'};
`;
